/** User-facing copy when the music-processing API is unavailable. */
export const PROCESSING_API_UNAVAILABLE_MESSAGE =
  "Music processing is temporarily unavailable. Please try again later or contact support if this continues.";
